import { Services } from "appworks/services/services";
import { JurisdictionService } from "slotworks/services/jurisdiction/jurisdiction-service";
import { ButtonControl } from "./button-control";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { AgsRollUpState } from "ags/state-machine/states/ags-roll-up-state";
import { stateMachine } from "appworks/state-machine/state-machine";

export class AutoplayControl extends ButtonControl {
    protected inProgressFlags = [UIFlag.PROMPT, UIFlag.FREE_SPINS, UIFlag.BIG_WIN_DELAY, UIFlag.BIG_WIN, UIFlag.GAME_IN_PROGRESS];
    
    public setEnabled(enabled: boolean) {
        const juriAllowsAutoplay = Services.get(JurisdictionService).getAutoplayEnabled();

        if (!juriAllowsAutoplay) {
            super.setEnabled(false);
            this.button.setVisible(false);
        } else {
            const isMidRollup = (stateMachine.superState?.concrete ?? null) != null && stateMachine.superState.concrete instanceof AgsRollUpState && !stateMachine.superState.concrete.isRollupComplete();
            const isInProgress = this.inProgressFlags.some((flag) => uiFlags.has(flag)) || isMidRollup;
            const shouldEnableButton = enabled && (uiFlags.has(UIFlag.IDLE) || !isInProgress);
            super.setEnabled(shouldEnableButton);
        }
    }
}
